import { Box } from "@mui/material";
import { FC } from "react";
import { Asset } from "../../models/schema";
import { ExternalLink } from "./ExternalLink";

type SocialButtonProps = {
  link?: string;
  logo?: Asset;
  grayScale?: boolean;
};

const Logo = ({ logo, grayScale }: SocialButtonProps) => (
  <Box
    component="img"
    sx={(theme) => ({
      width: theme.spacing(8),
      height: theme.spacing(8),
      borderRadius: 1,
      filter: grayScale ? "grayscale(1)" : "none",
      "&:hover": {
        filter: "none"
      }
    })}
    src={logo?.url as string}
    alt={logo?.description as string}
  />
);

const SocialButton: FC<SocialButtonProps> = ({ link, logo, grayScale }) => {
  return (
    <ExternalLink href={link}>
      <Logo logo={logo} grayScale={grayScale} />
    </ExternalLink>
  );
};

export default SocialButton;
